import React, { Fragment } from 'react';
import { Dialog, FormControl, MenuItem, Checkbox, RadioGroup, Radio, Stack, Grid, Popover, Typography, Box, FormLabel, Paper, OutlinedInput } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import contractStyles from './contracts.module.css';
import { CustomButton, CustomTextField, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, InputProps, CustomSelect, CustomCheckbox, CustomRadio, CustomDialogContent, SelectInputProps, CustomFormHelperText } from '../../../../../custom/components';
import { CloseIconBtn, appliedOnItems, roles, platforms, LOCALE_OBJ, driversOptions, structureOptions } from 'custom/constants';
import { InfoOutlined } from '@mui/icons-material';

const AddContractItem = (props) => {

  const { action } = props;
  const LABEL_PROPS = {
    direction: {
      xs: 'column',
      sm: 'row' 
    },
    alignItems: {
      xs: 'flex-start',
      sm: 'center' 
    }
  };

  const NUMBERINPUT_PROPS = {
    '&[type=number]': { '-moz-appearance': 'textfield', },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none', },
    '& input[type=number]': { MozAppearance: 'textfield', },
  };

  const LABELSTYLE = {
    color: 'primary.main',
    fontWeight: 'bold',
    borderBottom: '1px solid #b6b6b6',
    paddingBottom: 1,
    marginBottom: 1,
    fontSize: 14,
  };

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'contract_item'} onClose={props.onClose} maxWidth={'lg'} fullWidth scroll='paper'>
        <CustomDialogTitle id='form-dialog-title'>
          {action == 'add' ? 'Add' : 'Edit'} Billable Line Item
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <CustomDialogContent>
          <StyledCard>
            <Grid container spacing={{
              xs: 1,
              sm: 3,
            }} columnSpacing={8}>
              <Grid item xs={12} sm={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='description' required className={contractStyles.labelInline}>Item Description</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    autoFocus
                    id='description'
                    placeholder='Description'
                    type='text'
                    name='description'
                    value={props.controwField.description}
                    onChange={props.onChangecontrowField}
                    error={props.controwErrors.description}
                    helperText={props.controwErrors.description}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='applied_on' required className={contractStyles.labelInline} sx={{ mb: 'auto' }}>Applied On</CustomInputLabel>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Paper elevation={0} sx={{
                        p: 1.8,
                        bgcolor: '#f7f7f7' 
                      }}>
                        <FormControl fullWidth component='fieldset'>
                          <FormLabel sx={LABELSTYLE}>Drivers</FormLabel>
                          <RadioGroup
                            aria-labelledby='drivers'
                            name='drivers'
                            row
                            id='drivers'
                            // defaultValue={'KGS'}
                            onChange = {props.handleRadioChange}
                            value={props.appliedOn.drivers}
                            // error={props.appliedOn.drivers}
                          >
                            <Grid container spacing={1} alignItems='center' flexWrap='wrap' justifyContent='space-between'>
                              {driversOptions.map(opt => (
                                <Grid item xs={'auto'} key={opt.value}>
                                  <CustomRadio
                                    control={<Radio size='small' />}
                                    value={opt.value}
                                    label={opt.label}
                                  />
                                </Grid>
                              ))}
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Paper>
                    </Grid>

                    <Grid item xs={12} container spacing={3}>
                      <Grid item xs={12} md={6} lg={6}>
                        <Paper elevation={0} sx={{
                          p: 2,
                          minHeight: '100px',
                          bgcolor: '#f7f7f7'
                        }} className={styles.h100}>
                          <FormControl component='fieldset' fullWidth>
                            <FormLabel sx={LABELSTYLE}>Structure</FormLabel>
                            <Grid container spacing={7} alignItems='center'>
                              <Grid item xs={6}>
                                <RadioGroup
                                  aria-labelledby='structure'
                                  name='structure'
                                  onChange={props.handleRadioChange}
                                  row
                                  defaultValue={'total'}
                                  value={props.appliedOn.structure}
                                  disabled={props.appliedOn.drivers === 'units'}
                                >
                                  <Stack direction='row' spacing={2} flexWrap='wrap' justifyContent='space-between' flex={1}>
                                    {props.appliedOn?.structureType ? Array.isArray(structureOptions[props.appliedOn.structureType]) && structureOptions[props.appliedOn.structureType].length > 0 &&
                                        structureOptions[props.appliedOn.structureType].map(option => (
                                          <CustomRadio
                                            key={option.value}
                                            control={<Radio size='small' />}
                                            value={option.value}
                                            label={option.label}
                                            disabled={props.appliedOn.drivers === 'units' && option.value.toLowerCase() === 'total'}
                                          />
                                        )) : <></>
                                    }
                                  </Stack>
                                </RadioGroup>
                              </Grid>
                              <Grid item xs minWidth={'120px'}>
                                {props.appliedOn.structure === 'Intact' &&
                                    <FormControl variant='outlined' fullWidth className={`${styles.borderedIpTextfield}`}>
                                      <CustomSelect
                                        {...SelectInputProps}
                                        id='type'
                                        labelId='type-label'
                                        fullWidth
                                        name='type'
                                        value={!props.appliedOn.type ? 'placeholder' : props.appliedOn.type}
                                        disabled={props.appliedOn.structure !== 'Intact'}
                                        onChange={props.handleRadioChange}
                                        classes={{ 
                                          select: !props.controwField.productId ? styles.colorPlaceholder : '',
                                          root: styles.borderedIpRoot,
                                          input: styles.borderedIp,
                                        }}
                                        input={<OutlinedInput 
                                          classes={{
                                            notchedOutline: styles.notchedOutline,
                                            error: styles.errorInput,
                                          }} 
                                        />}
                                      >
                                        <MenuItem value='placeholder' disabled >Select Type</MenuItem>
                                        {/* {['KGs', 'MD', 'LD3', 'LD7'].map((type, i) => ( */}
                                        <MenuItem key={'All'} value={'Total'}>{'All'}</MenuItem>
                                        <MenuItem key={'KGs'} value={'KGs'}>{'KGs'}</MenuItem>
                                        <MenuItem key={'MD'} value={'MD'}>{'MD'}</MenuItem>
                                        <MenuItem key={'LD3'} value={'LD3'}>{'LD3'}</MenuItem>
                                        <MenuItem key={'LD7'} value={'LD7'}>{'LD7'}</MenuItem>
                                        {/* ))} */}
                                      </CustomSelect>
                                    </FormControl>
                                }
                              </Grid>
                            </Grid>
                          </FormControl>
                        </Paper>
                      </Grid>

                      {/* Product Specific */}
                      <Grid item xs={12} md={6} lg={6}>
                        <Paper elevation={0} sx={{
                          p: 2,
                          minHeight: '100px',
                          bgcolor: '#f7f7f7'
                        }} className={styles.h100}>
                          <FormControl component='fieldset' fullWidth>
                            <FormLabel sx={LABELSTYLE}>Product Specific</FormLabel>
                            {
                              (props.appliedOn.drivers === 'KGs' || props.appliedOn.drivers === 'Air Waybill' || props.appliedOn.drivers === '(Pcs)') && 
                                <Grid container spacing={2} alignItems='center'>
                                  <Grid item xs>
                                    <RadioGroup
                                      aria-labelledby='productSpecific'
                                      name='productSpecific'
                                      onChange={props.handleRadioChange}
                                      value={props.appliedOn.productSpecific}
                                      row
                                      defaultValue={'no'}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between' 
                                      }}
                                    >
                                      <CustomRadio control={<Radio size='small' />} value='' label='None' 
                                        // disabled={props.appliedOn.drivers === 'uld' || props.appliedOn.drivers === 'units'}
                                      />
                                      <CustomRadio control={<Radio size='small' />} value='Gen' label='Gen' 
                                        disabled={props.appliedOn.drivers === 'uld' || props.appliedOn.drivers === 'units'}
                                      />
                                      <CustomRadio control={<Radio size='small' />} value='SPL' label='SPL' 
                                        disabled={props.appliedOn.drivers === 'uld' || props.appliedOn.drivers === 'units'}
                                      />
                                    </RadioGroup>
                                  </Grid>
                                  <Grid item xs='auto' width={'150px'}>
                                    <FormControl variant='outlined' fullWidth className={`${styles.borderedIpTextfield}`}>
                                      <CustomSelect
                                        {...SelectInputProps}
                                        id='productId'
                                        labelId='product-label'
                                        fullWidth
                                        name='productId'
                                        value={!props.controwField.productId ? 'placeholder' : props.controwField.productId}
                                        disabled={props.appliedOn.productSpecific !== 'SPL' || 
                                          (!props?.controwField?.applied_on?.includes('SPL') && !props?.controwField?.applied_on?.includes('Air Waybill') )}
                                        onChange={props.onChangecontrowField}
                                        classes={{ 
                                          select: !props.controwField.productId ? styles.colorPlaceholder : '',
                                          root: styles.borderedIpRoot,
                                          input: styles.borderedIp,
                                        }}
                                        input={<OutlinedInput 
                                          classes={{
                                            notchedOutline: styles.notchedOutline,
                                            error: styles.errorInput,
                                          }} 
                                        />}
                                      >
                                        <MenuItem value='placeholder' disabled >Select Product</MenuItem>
                                        {props.products.map((product, i) => (
                                          <MenuItem key={i} value={product.id}>
                                            {product.name}
                                          </MenuItem>
                                        ))}
                                      </CustomSelect>
                                    </FormControl>
                                  </Grid>
                                </Grid>
                            }
                          </FormControl>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>

              <Grid item xs={12} md={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel id='applied_on_label' required className={contractStyles.labelInline}>Applied On</CustomInputLabel>
                  {props.controwField.applied_on ? 
                    <CustomRadio control={<Radio size='small' defaultChecked />} value='progressive' label={props.controwField.applied_on} sx={{ mr: 1 }} />
                    : <div>-</div> }
                  <InfoOutlined color='inherit' fontSize='small' sx={{
                    opacity: 0.4,
                    marginTop: '6px',
                    marginBottom: 'auto'
                  }} onClick={(e) => props.handlePopover(true, e.target, null, null)} className={`${styles.ml2} ${styles.pointer}`} />
                </Stack>
              </Grid>
              {
                props.controwField.is_nonbillable ? '' :
                  <>
                    <Grid item xs={12} md={6}>
                      <Stack {...LABEL_PROPS}>
                        <CustomInputLabel htmlFor='rate_type' required className={contractStyles.labelInline}>Rate Type</CustomInputLabel>
                        <RadioGroup aria-labelledby='' name='rate_type' id='rate_type' value={props.controwField.rate_type} onChange={props.onChangecontrowField} row >
                          <CustomRadio control={<Radio size='small' />} value='stable' label='Stable' sx={{ mr: 1 }} />
                          {/* {(props.controwField.applied_on === 'Units (Pcs) | Manual' || (props.controwField.applied_on === 'Units (Hourly) | Manual')) ? '' :  */}
                          { props.controwField.rate_type_options !== 'All' ? '' : 
                            <>
                              <CustomRadio control={<Radio size='small' />} value='progressive' label='Tiered - Progressive' sx={{ mr: 1 }} />
                              <CustomRadio control={<Radio size='small' />} value='absolute' label='Tiered - Absolute' />
                            </>}
                        </RadioGroup>
                      </Stack>
                    </Grid>

                    { props.controwField.applied_on === 'Units | Manual' ?
                      <Grid item xs={12} md={6}>
                        <Stack {...LABEL_PROPS}>
                          <CustomCheckbox
      
                            control={
                              <Checkbox name='link_existing_tiered' size='small' 
                                checked={props.controwField.link_contract} 
                                onChange={() => {
                                  props.onChangecontrowField({
                                    target: {
                                      name: 'link_contract',
                                      value: !props.controwField.link_contract 
                                    }
                                  });
                                }}
                                disabled={props.controwField.rate_type === 'stable'}
                              />
                            }
                            className={styles.spaceNowrap}
                            label='Link to existing tiered contract item'
                          />
                          <FormControl variant='standard' fullWidth>
                            <CustomSelect
                              {...SelectInputProps}
                              fullWidth
                              // value={!props.controwField.productId ? 'placeholder' : props.controwField.productId}
                              // classes={{ select: !props.controwField.productId ? styles.colorPlaceholder : '' }}
                              id='refId'
                              labelId='product-label'
      
                              name='refId'
                              value={!props.controwField.refId ? 'placeholder' : props.controwField.refId}
                              disabled={!props.controwField.link_contract}
                              onChange={props.onChangecontrowField}
                            >
                              <MenuItem value='placeholder' disabled >Select Contract Item</MenuItem>
                              {props.dropdown_contracts.filter(row => row.rate_type === props.controwField.rate_type).map((row, i) => (
                                <MenuItem key={i} value={row.id}>
                                  {row.description}
                                </MenuItem>
                              ))}
                            </CustomSelect>
                          </FormControl>
                        </Stack>
                      </Grid> : ''
                    }
                    <Grid item xs={12} sm={12}>
                      <Stack {...LABEL_PROPS}>
                        <CustomInputLabel htmlFor='rate' required className={contractStyles.labelInline}>Rate</CustomInputLabel>
                        { 
                          props.controwField.rate_type == 'stable' ?
                            <Grid container rowSpacing={2} columnSpacing={2}>
                              <Grid item xs={12} sm={12} md={4.6}>
                                <Stack direction='row' alignItems='center' spacing={1}>
                                  <CustomTextField
                                    {...InputProps}
                                    fullWidth
                                    id='rate'
                                    placeholder='Stable Rate'
                                    type='text'
                                    name='rate'
                                    value={props.contrateField.rate}
                                    onChange={props.onChangecontrateField}
                                    onBlur={() => props.handleNumberFormat(props.contrateField.rate, 'rate')}
                                    onFocus={() => props.handleOnFocus(props.contrateField.rate, 'rate')}
                                    error={props.contrateErrors.rate}
                                    helperText={props.contrateErrors.rate}
                                  />
                                </Stack>
                              </Grid>
                            </Grid>
                            :
                            <Grid container rowSpacing={2} columnSpacing={2}>
                              <Grid item xs={12} sm={12} md={4}>
                                <CustomInputLabel  htmlFor='level1 rate1' aria-label='Enter Tier 1' className={`${contractStyles.labelInline} ${styles.mt0}`}>Tier1</CustomInputLabel>
                                <FormControl variant='standard' fullWidth error={props.contrateErrors.level1 || props.contrateErrors.rate1}>
                                  <Stack direction={'row'} alignItems='center' columnGap={1} rowGap={1} flexWrap={'wrap'}>
                                    <CustomTextField
                                      {...InputProps}
                                      id='level1low'                         
                                      placeholder='Tier1'
                                      type='text'
                                      name='level1low'
                                      value={props.contrateField.level1low ? Number(props.contrateField.level1low).toLocaleString(LOCALE_OBJ.locale) : 0}
                                      disabled
                                      sx={NUMBERINPUT_PROPS}
                                      className={contractStyles.rateInput}
                                    />
                                    <CustomTextField
                                      {...InputProps}
                                      id='level1'                         
                                      placeholder='Tier Limit'
                                      type='text'
                                      name='level1'
                                      value={props.contrateField.level1}
                                      onBlur={() => props.handleNumberFormat(props.contrateField.level1, 'level1')}
                                      onFocus={() => props.handleOnFocus(props.contrateField.level1, 'level1')}
                                      onChange={props.onChangecontrateField}
                                      sx={NUMBERINPUT_PROPS}
                                      className={contractStyles.rateInput}
                                      disabled={props.controwField.link_contract}
                                    />
                                    <CustomTextField
                                      {...InputProps}
                                      id='rate1'                         
                                      placeholder='Rate'
                                      type='text'
                                      name='rate1'
                                      value={props.contrateField.rate1}
                                      onChange={props.onChangecontrateField}
                                      onBlur={() => props.handleNumberFormat(props.contrateField.rate1, 'rate1')}
                                      onFocus={() => props.handleOnFocus(props.contrateField.rate1, 'rate1')}
                                      disabled={props.controwField.link_contract || !props.contrateField.level1 || isNaN(props.contrateField.level1 && props.contrateField?.level1.replace(/,/g, '')) ? true : false}
                                      sx={NUMBERINPUT_PROPS}
                                      className={contractStyles.rateInput}
                                    />
                                  </Stack>
                                  <CustomFormHelperText>{props.contrateErrors.level1 || props.contrateErrors.rate1}</CustomFormHelperText>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} sm={12} md={4}>
                                <CustomInputLabel htmlFor='level2 rate2' aria-label='Enter Tier2' className={`${contractStyles.labelInline} ${styles.mt0}`}>Tier2</CustomInputLabel>                          
                                <FormControl variant='standard' fullWidth error={props.contrateErrors.level2 || props.contrateErrors.rate2}>
                                  <Stack direction={'row'} alignItems='center' columnGap={1} rowGap={1} flexWrap={'wrap'}>
                                    <CustomTextField
                                      {...InputProps}
                                      id='level2low'                         
                                      placeholder='Tier2'
                                      type='text'
                                      name='level2low'
                                      value={props.contrateField.level2low && !isNaN(props.contrateField.level2low) ? Number.parseFloat(props.contrateField.level2low).toLocaleString(LOCALE_OBJ.locale, LOCALE_OBJ.options) : ''}
                                      disabled
                                      sx={NUMBERINPUT_PROPS}
                                      className={contractStyles.rateInput}
                                    />
                                    <Box className={`${contractStyles.rateInput} ${styles.fColumn}`} sx={{ marginTop: '-20px' }}>
                                      <CustomCheckbox
                                        className={contractStyles.noLimitWrapper}
                                        control={
                                          <Checkbox inputProps={{ 'aria-label': 'no limit', }} disableRipple className={`${styles.py0} ${styles.pr1}`} 
                                            checked={props.contrateField.nolimit2} 
                                            onChange={() => {
                                              props.onChangecontrateField({
                                                target: {
                                                  name: 'nolimit2',
                                                  value: !props.contrateField.nolimit2 
                                                }
                                              });
                                            }} 
                                            name='nolimit2'
                                            disabled={props.controwField.link_contract}
                                          />
                                        }
                                        label='No Limit'
                                      />
                                      <CustomTextField
                                        {...InputProps}
                                        id='level2'                         
                                        placeholder='Tier Limit'
                                        type='text'
                                        name='level2'
                                        value={props.contrateField.level2}
                                        onChange={props.onChangecontrateField}
                                        onBlur={() => props.handleNumberFormat(props.contrateField.level2, 'level2')}
                                        onFocus={() => props.handleOnFocus(props.contrateField.level2, 'level2')}
                                        sx={NUMBERINPUT_PROPS}
                                        disabled={props.contrateField.nolimit2 || props.controwField.link_contract}
                                      />
                                    </Box>
                                    <CustomTextField
                                      {...InputProps}
                                      id='rate2'                         
                                      placeholder='Rate'
                                      type='text'
                                      name='rate2'
                                      value={props.contrateField.rate2}
                                      onChange={props.onChangecontrateField}
                                      onBlur={() => props.handleNumberFormat(props.contrateField.rate2, 'rate2')}
                                      onFocus={() => props.handleOnFocus(props.contrateField.rate2, 'rate2')}
                                      disabled={props.controwField.link_contract ? true : props.contrateField.nolimit2 ? false : !props.contrateField.level2 || isNaN(props.contrateField.level2 && props.contrateField?.level2.replace(/,/g, '')) ? true : false}
                                      sx={NUMBERINPUT_PROPS}
                                      className={contractStyles.rateInput}
                                    />
                                  </Stack>
                                  <CustomFormHelperText>{props.contrateErrors.level2 || props.contrateErrors.rate2}</CustomFormHelperText>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} sm={12} md={4}>
                                <CustomInputLabel  htmlFor='level3 rate3' aria-label='Enter Tier3' className={`${contractStyles.labelInline} ${styles.mt0}`}>Tier3</CustomInputLabel>
                                <FormControl variant='standard' fullWidth error={props.contrateErrors.level3 || props.contrateErrors.rate3}>
                                  <Stack direction={'row'} alignItems='center' columnGap={1} rowGap={1} flexWrap={'wrap'}>
                                    <CustomTextField
                                      {...InputProps}
                                      fullWidth
                                      id='level3low'                         
                                      placeholder='Tier3'
                                      type='text'
                                      name='level3low'
                                      value={props.contrateField.level3low && !isNaN(props.contrateField.level3low)? Number.parseFloat(props.contrateField.level3low).toLocaleString(LOCALE_OBJ.locale, LOCALE_OBJ.options).toString() : ''}
                                      disabled
                                      sx={NUMBERINPUT_PROPS}
                                      className={contractStyles.rateInput}
                                    />
                                    <Box className={`${contractStyles.rateInput} ${styles.fColumn}`} sx={{ marginTop: '-20px' }}>
                                      <CustomCheckbox
                                        className={contractStyles.noLimitWrapper}
                                        control={
                                          <Checkbox inputProps={{ 'aria-label': 'no limit', }} disableRipple className={`${styles.py0} ${styles.pr1}`} 
                                            checked={props.contrateField.nolimit3} 
                                            onChange={() => props.onChangecontrateField({
                                              target: {
                                                name: 'nolimit3',
                                                value: !props.contrateField.nolimit3 
                                              }
                                            })} 
                                            name='nolimit3'
                                            disabled={props.controwField.link_contract || props.contrateField.nolimit2 || props.contrateField.level3low === '-'}
                                          />
                                        }
                                        label='No Limit'
                                      />
                                      <CustomTextField
                                        {...InputProps}
                                        fullWidth
                                        id='level3'                         
                                        placeholder='Tier Limit'
                                        type='text'
                                        name='level3'
                                        value={props.contrateField.level3}
                                        onChange={props.onChangecontrateField}
                                        onBlur={() => props.handleNumberFormat(props.contrateField.level3, 'level3')}
                                        onFocus={() => props.handleOnFocus(props.contrateField.level3, 'level3')}
                                        sx={NUMBERINPUT_PROPS}
                                        disabled={props.controwField.link_contract || props.contrateField.nolimit3 || props.contrateField.nolimit2 || props.contrateField.level3low === '-' }
                                      />
                                    </Box>
                                    <CustomTextField
                                      {...InputProps}
                                      fullWidth
                                      id='rate3'                         
                                      placeholder='Rate'
                                      type='text'
                                      name='rate3'
                                      value={props.contrateField.rate3}
                                      onChange={props.onChangecontrateField}
                                      onBlur={() => props.handleNumberFormat(props.contrateField.rate3, 'rate3')}
                                      onFocus={() => props.handleOnFocus(props.contrateField.rate3, 'rate3')}
                                      disabled={props.controwField.link_contract ? true : props.contrateField.nolimit3 ? false : props.contrateField.nolimit2 || !props.contrateField.level3 || isNaN(props.contrateField.level3 && props.contrateField?.level3.replace(/,/g, '')) ? true : false}
                                      sx={NUMBERINPUT_PROPS}
                                      className={contractStyles.rateInput}
                                    />
                                  </Stack>
                                  <CustomFormHelperText>{props.contrateErrors.level3 || props.contrateErrors.rate3}</CustomFormHelperText>
                                </FormControl>
                              </Grid>
                            </Grid>
                        }
                      </Stack>
                    </Grid>
                  </>
              }
              <Grid item xs={12} md={6}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='minimum' aria-label='Minimum' className={contractStyles.labelInline}>Minimum</CustomInputLabel>
                  <>
                    <CustomCheckbox
                      control={
                        <Checkbox inputProps={{ 'aria-label': 'minimum', }}  checked={props.controwField.is_minimum} onChange={props.onChangecontrowField} name='is_minimum' size='small' disabled={props.controwField.link_contract} />
                      }
                      label=''
                      classes={{ root: styles.mr2 }}
                    />
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='minimum'
                      placeholder='Minimum Rate'
                      type='text'
                      InputProps={{ ...InputProps.InputProps }}
                      sx={{ marginRight: '28px', }}
                      name='minimum'
                      value={props.controwField.minimum}
                      onBlur={() => props.handleNumberFormat(props.controwField.minimum, 'minimum')}
                      onFocus={() => props.handleOnFocus(props.controwField.minimum, 'minimum')}
                      onChange={props.onChangecontrowField}
                      disabled={props.controwField.link_contract? true : props.controwField.is_minimum ? false : true}
                    />
                  </>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel id='role_label' className={contractStyles.labelInlineRhs}>To be entered by (Employee Group)</CustomInputLabel>
                  <FormControl variant='standard' fullWidth error={props.controwErrors.roles}>
                    <CustomSelect
                      {...SelectInputProps}
                      id='role'
                      labelId='role_label'
                      fullWidth
                      name='roles'
                      disabled={!props.controwField.applied_on ? true : props.controwField?.applied_on?.includes('Auto') ? true: false}
                      value={!props.controwField.roles? ['N/A'] : props.controwField.roles[0] || props.controwField.roles}
                      onChange={props.onChangecontrowField}
                      classes={{ select: !props.controwField.roles ? styles.colorPlaceholder : '' }}
                    >
                      <MenuItem value='placeholder' disabled>Select Role</MenuItem>
                      <MenuItem value={'N/A'}>N/A</MenuItem>
                      { roles.map((role) => (
                        <MenuItem key={role.id} value={role.value}>
                          {role.value}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                    <CustomFormHelperText>{props.controwErrors.role}</CustomFormHelperText>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack {...LABEL_PROPS} sx={{ marginRight: '28px', }}>
                  <CustomInputLabel id='record_on_label' required className={contractStyles.labelInline}>Record On</CustomInputLabel>
                  <FormControl variant='standard' fullWidth error={props.controwErrors.record_on}>
                    <CustomSelect
                      {...SelectInputProps}
                      id='record_on'
                      labelId='record_on_label'
                      fullWidth
                      name='record_on'
                      value={!props.controwField.record_on ? 'placeholder' : props.controwField.record_on}
                      onChange={props.onChangecontrowField}
                      classes={{ select: !props.controwField.record_on ? styles.colorPlaceholder : '' }}
                      disabled={props.controwField.link_contract ? true : props.controwField.applied_on ? false : true}
                    >
                      <MenuItem value='placeholder' disabled>Select Record On</MenuItem>
                      {
                        props.recordOns.map((record) => (
                          <MenuItem key={record} value={record}>
                            {record}
                          </MenuItem>
                        ))
                      }
                    </CustomSelect>
                    <CustomFormHelperText>{props.controwErrors.record_on}</CustomFormHelperText>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='platform' aria-label='Platform' className={contractStyles.labelInlineRhs}>Platform</CustomInputLabel>
                  <>
                    <CustomSelect
                      {...SelectInputProps}
                      id='platform'
                      labelId='platform-label'
                      onChange={props.onChangecontrowField}
                      name='platform'
                      value={!props.controwField.platform ? 'N/A' : props.controwField.platform}
                      classes={{ select: !props.controwField.platform ? styles.colorPlaceholder : '' }}
                      fullWidth
                      disabled={ props.controwField.link_contract ? true : !props.controwField.record_on ? true : props.controwField.record_on === 'Month Log' || props.controwField.record_on ===  'Day Log' ? true : false }
                    >
                      <MenuItem value='placeholder'>Select a Platform</MenuItem>
                      <MenuItem value={'N/A'}>N/A</MenuItem>
                      {platforms.map((name) => (
                        <MenuItem key={name} value={name}>{name}</MenuItem>
                      ))}
                    </CustomSelect>
                  </>
                </Stack>
              </Grid>
                
              <Grid item xs={12} sm={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel id='segment_label' className={contractStyles.labelInline}>Segment</CustomInputLabel>
                  <FormControl variant='standard' fullWidth error={props.controwErrors.segment}>
                    <CustomSelect
                      {...SelectInputProps}
                      id='segment'
                      labelId='segment_label'
                      fullWidth
                      name='segment'
                      value={!props.controwField.segment ? 'N/A' : props.controwField.segment}
                      onChange={props.onChangecontrowField}
                      classes={{ select: !props.controwField.segment ? styles.colorPlaceholder : '' }}
                      disabled={props.controwField.link_contract? true : props.controwField.applied_on ? false : true}
                    >
                      <MenuItem value='placeholder' disabled>Select Segment</MenuItem>
                      {/* <MenuItem value={'Import'}>Import</MenuItem>
                        <MenuItem value={'Export'}>Export</MenuItem>
                        <MenuItem value={'Transit'}>Transit</MenuItem> */}
                      {
                        props.segments.map((segment) => (
                          <MenuItem key={segment} value={segment}>
                            {segment}
                          </MenuItem>
                        ))
                      }
                      <MenuItem value={'N/A'}>N/A</MenuItem>
                    </CustomSelect>
                    <CustomFormHelperText>{props.controwErrors.segment}</CustomFormHelperText>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel id='exclude_label' className={contractStyles.labelInline}>Exclude</CustomInputLabel>
                  <FormControl variant='standard' fullWidth error={props.controwErrors.exclude}>
                    <CustomSelect
                      {...SelectInputProps}
                      id='exclude'
                      labelId='exclude_label'
                      fullWidth
                      name='exclude'
                      multiple={true}
                      value={props.controwField.exclude || []}
                      onChange={props.onChangecontrowField}
                      classes={{ select: !props.controwField.exclude ? styles.colorPlaceholder : '' }}
                      disabled={props.controwField.link_contract ? true : props.controwField.applied_on ? false : true}
                    >
                      <MenuItem value='placeholder' disabled>Select Exclude</MenuItem>
                      <MenuItem value={'sameDestinationTransitShipments'}>Shipments where Flight and Cargo Destinations are in the United States</MenuItem>
                    </CustomSelect>
                    <CustomFormHelperText>{props.controwErrors.exclude}</CustomFormHelperText>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='remarks' className={contractStyles.labelInline}>Remarks</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    id='remarks'
                    placeholder=''
                    type='text'
                    name='remarks'
                    value={props.controwField.remarks}
                    onChange={props.onChangecontrowField}
                  />
                </Stack>
              </Grid>
            </Grid>
          </StyledCard>

        </CustomDialogContent>
        <CustomDialogAction className={`${styles.fSpaceBtw} ${styles.pt1}`}>
          <CustomButton variant='contained' type='reset' onClick={props.onClose}> Close </CustomButton> 
          <CustomButton variant='contained' type='submit' onClick={action == 'add' ? props?.addControw : props.editControw}> 
            {action == 'add' ? 'Submit' : 'Update'} 
          </CustomButton> 
        </CustomDialogAction>
      </Dialog>

      <Popover
        open={props.attachment}
        anchorEl={props.anchorEl}
        onClose={() => props.handlePopover(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Box className={contractStyles.popoverWrapper}>
          {appliedOnItems.map((item, i) => 
            <div key={i} className={`${styles.dFlex} ${contractStyles.desc}`}>
              <Typography variant='caption' component={'p'} marginBottom={0} whiteSpace={'nowrap'} className={`${styles.minWidth170}`}>
                {`${item.label}`}
              </Typography>
              <Typography variant='caption' component={'p'} marginBottom={0}>
                {`${item.desc}`}
              </Typography>
            </div>
          )}
        </Box>
      </Popover>
    </div>
  );
};
export default AddContractItem;